import { create } from 'zustand';
import type { MatchConfig } from '../api/types';

export const DEFAULT_CONFIG: MatchConfig = {
  minScore: 0.3,
  minEvent: 0.25,
  minLocation: 0.20,
  minTime: 0.15,
  rerankTopM: 10,
  fusionAlpha: 0.75,
  weights: {
    event: 0.30,
    location: 0.25,
    time: 0.15,
    appearance: 0.10,
    habits: 0.05,
    mirrorConsistency: 0.10,
    uniquenessBonus: 0.05,
  },
};

interface ConfigState {
  config: MatchConfig;
  isModified: boolean;

  // Actions
  setGate: (key: 'minScore' | 'minEvent' | 'minLocation' | 'minTime', value: number) => void;
  setRerankTopM: (value: number) => void;
  setFusionAlpha: (value: number) => void;
  setWeight: (key: keyof MatchConfig['weights'], value: number) => void;
  resetToDefaults: () => void;
  loadConfig: (config: MatchConfig) => void;
}

export const useConfigStore = create<ConfigState>((set) => ({
  config: { ...DEFAULT_CONFIG },
  isModified: false,

  setGate: (key, value) => {
    set((state) => ({
      config: { ...state.config, [key]: value },
      isModified: true,
    }));
  },

  setRerankTopM: (value) => {
    set((state) => ({
      config: { ...state.config, rerankTopM: value },
      isModified: true,
    }));
  },

  setFusionAlpha: (value) => {
    set((state) => ({
      config: { ...state.config, fusionAlpha: value },
      isModified: true,
    }));
  },

  setWeight: (key, value) => {
    set((state) => ({
      config: {
        ...state.config,
        weights: { ...state.config.weights, [key]: value },
      },
      isModified: true,
    }));
  },

  resetToDefaults: () => {
    set({
      config: { ...DEFAULT_CONFIG },
      isModified: false,
    });
  },

  loadConfig: (config) => {
    set({
      config: { ...config },
      isModified: false,
    });
  },
}));
